

































import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import type { MergeValues, Form, EBlockWidth } from '@getaccept/editor-lib';
import { Context, FieldInputType } from '@getaccept/editor-lib';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import InputSet from './InputSet.vue';
import EditorNodeWrapper from './EditorNodeWrapper.vue';

export default defineComponent({
  name: 'EditorNodeForm',
  components: {
    InputSet,
    EditorNodeWrapper,
  },
  props: {
    node: { type: Object as PropType<Form>, default: () => ({}) },
    context: { type: String as PropType<Context>, default: () => Context.Document },
    mergeValues: { type: Object as PropType<MergeValues>, required: true },
    isMobile: { type: Boolean },
    blockWidthClass: {
      type: String as PropType<EBlockWidth>,
      default: null,
    },
    focusedRequiredId: { type: String, default: '' },
    isSigningSite: { type: Boolean },
    sender: {
      type: Object as PropType<User>,
      default: () => ({}),
    },
    recipient: {
      type: Object as PropType<Recipient>,
      default: () => ({}),
    },
    recipientInput: { type: Array as PropType<EditorRecipientInput[]>, required: true },
    isPdfViewer: { type: Boolean, default: false },
    updatingInputs: { type: Array as PropType<EditorRecipientInput[]>, required: true },
    failedInputUpdates: { type: Array as PropType<EditorRecipientInput[]>, required: true },
  },
  setup(props, { emit }) {
    const updateInputValue = (id: string, value: string) => {
      emit('update-input-value', { id, value });
    };

    const getFieldById = (id: string) => props.node.fields.find(field => field.id === id);

    const inputSets = computed(() =>
      props.node.inputFieldSets.map(inputSet => inputSet.ids.map(getFieldById))
    );

    return {
      FieldInputType,
      updateInputValue,
      inputSets,
      getFieldById,
    };
  },
});
